import React, { useState, useEffect, useRef } from 'react'
import {
  makeStyles,
  createStyles,
  useTheme,
  useMediaQuery,
  Box,
  Button,
  Typography,
  CircularProgress,
  Divider,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogActions,
  FormControlLabel,
} from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getPrice } from 'src/store/slices/userSlice'
// import { getUserInfo } from 'src/store/slices/authSlice'
import { AGREEMENT_ID_MAP, MOBILE_HEADER_HEIGHT, PACKAGE_INFO } from 'src/utils/constant'
import { useCustomTranslation, useDateFnsLocale } from 'src/hooks'
import { API } from 'src/store/api'
import InfoWrapper from 'src/mobile/components/InfoWrapper'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
// import CallOutlinedIcon from '@material-ui/icons/CallOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'
import EDrawer from 'src/mobile/themes/components/EDrawerColor'
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import DetailModal from 'src/mobile/components/DetailModal'
import ClinicStep from 'src/mobile/components/ClinicStep'
import translationHK from 'src/assets/locales/zh-HK/translation.json'
import { beginCheckout } from 'src/utils/trackingCode' 

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      alignItems: 'flex-start',
    },
    label: {
      fontSize: 18,
      lineHeight: 1.5,
      color: '#4B5563',
      marginTop: '-10px',
      [theme.breakpoints.down('md')]: {
        fontSize: 14,
        marginTop: 0,
      },
    },
    checkbox: {
      fontSize: 27,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      // color: theme.palette.primary.contrastText,
    },
    sidebarTank: {
      width: theme.spacing(40),
      flexShrink: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingTop: theme.spacing(4),
      backgroundColor: '#fff',
    },
    sidebarContent: {
      flexGrow: 1,
      padding: 0,
      maxWidth: theme.spacing(150),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(5),
      paddingRight: '106px',

      borderLeft: '1px solid #E5E7EB',
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    },
    flexLayout: {
      display: 'flex',
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0, 0),
        paddingTop: theme.spacing(MOBILE_HEADER_HEIGHT + 2),
      },
      [theme.breakpoints.down('md')]: {
        // backgroundColor: '#FAFAFA',
      },
    },
    spacingDivider: {
      background: '#E5E7EB',
      maxWidth: 850,
      margin: theme.spacing(2),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(5),
    },
  }),
)

const AddOrder = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const rejectRef = useRef(null)
  const { t } = useTranslation()
  const [tB] = useCustomTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { formatDate } = useDateFnsLocale()
  const { addOrderStatus, payStatus } = useSelector((state) => state.user)
  const { selectedDoctor } = useSelector((state) => state.testCenter)
  const [agreement, setAgreement] = useState({})
  const [check, setCheck] = useState(false)
  const { userInfo } = useSelector((state) => state.auth)

  const [agreementStatus, setAgreementStatus] = useState('')
  const [openAgreement, setOpenAgreement] = useState(false)
  // const isAddOrder = useRouteMatch('/add-order')
  // const isAddOrderStep = useRouteMatch('/add-order/success/') || useRouteMatch('/add-order/paying/')

  useEffect(() => {
    // dispatch(getUserInfo())
    dispatch(
      getPrice({
        testCenterId: selectedDoctor?.testCenterId,
        doctorId: selectedDoctor.doctorId,
        package: selectedDoctor?.package,
      }),
    )
  }, [])

  useEffect(() => {
    if (selectedDoctor) {
      // TagManager.dataLayer({
      //   dataLayer: {
      //     ecommerce: null,
      //   },
      // })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'checkout',
      //     ecommerce: {
      //       checkout: {
      //         actionField: { step: 1 },
      //         products: [
      //           {
      //             name: selectedDoctor[tB('name')] || '',
      //             id: `${selectedDoctor.id || ''}`,
      //             price: `${priceAndCurrency?.price || ''}`,
      //             brand: selectedDoctor.testCenterName || '',
      //             category: selectedDoctor[tB('honoraryTitle')] || '',
      //             variant: selectedDoctor.appointmentTime || '',
      //             dimension1: selectedDoctor.appointmentDate || '',
      //             quantity: 1,
      //           },
      //         ],
      //       },
      //     },
      //   },
      // })
    } else {
      history.push('/')
    }
  }, [selectedDoctor])

  useEffect(async () => {
    setAgreementStatus('pending')
    try {
      const res = await API.getAgreementInfo({ id: AGREEMENT_ID_MAP.orderAgreement.id })
      res.data && setAgreement(res.data)
      setAgreementStatus('fulfilled')
    } catch (error) {
      setAgreementStatus('rejected')
    }
  }, [])

  const handleCloseAgreement = (e) => {
    if (e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Shift')) {
      return
    }
    rejectRef.current && rejectRef.current()
    setOpenAgreement(false)
    setCheck(true)
    if (userInfo) {
      history.push('/add-order')
    } else {
      history.push('/add-order/signin')
    }
  }
  const handleChangeCheck = (event) => {
    setCheck(event.target.checked)
  }

  const addTrackingCode = () => {
    const title  = PACKAGE_INFO[Number(selectedDoctor?.package)].title
    const titleArr = title.split('.')
    const len = titleArr.length -1;
    let name;
    let num =0
    let obj = translationHK;
    while(num <= len ) {
      name = obj[titleArr[num]];
      obj = obj[titleArr[num]]
      num++
    }
    const ecommerce = { 
      currency: selectedDoctor.currency,
      value: selectedDoctor.price,
      items: [
        {
          item_id: PACKAGE_INFO[Number(selectedDoctor?.package)]?.id,
          item_name: name,
          index: PACKAGE_INFO[Number(selectedDoctor?.package)]?.index,
          price: selectedDoctor.price,
          item_category: selectedDoctor.testCenterAddressHk,
          item_category2: selectedDoctor.appointmentDate,
          item_category3: selectedDoctor.appointmentTime,
          item_category4: selectedDoctor.nameHk
        }
      ]
    }
    // addToCart(ecommerce)
    beginCheckout(ecommerce)
  }
  const renderButton = () => {
    return (
      <Box display="flex" justifyContent={isMobile ? 'space-around' : 'flex-end'}>
        <Button
          fullWidth={isMobile}
          style={{
            textDecoration: 'underline',
            color: '#000000',
            fontSize: isMobile ? '16px' : '18px',
            marginRight: isMobile ? 0 : '20px',
          }}
          onClick={() => history.push(`/clinic/${selectedDoctor.id}`)}
        >
          {t('common.back')}
        </Button>
        <Button
          fullWidth={isMobile}
          type="submit"
          style={{ width: !isMobile && '150px', fontSize: isMobile ? '16px' : '18px' }}
          size={isMobile ? 'medium' : 'large'}
          variant="contained"
          color="secondary"
          onClick={() => {
            addTrackingCode()
            if (check) {
              if (userInfo) {
                history.push('/add-order')
              } else {
                history.push('/add-order/signin')
              }
            } else {
              setOpenAgreement(true)
            }
          }}
        >
          {addOrderStatus === 'pending' || payStatus === 'pending' ? (
            <CircularProgress color="inherit" size={24} />
          ) : (
            t('common.go_on')
          )}
        </Button>
      </Box>
    )
  }
  return (
    <Box>
      {selectedDoctor && (
        <>
          <InfoWrapper>
            <Typography variant={isMobile ? 'h4' : 'h6'} noWrap>
              <DetailModal
                value={Number(selectedDoctor?.package)}
                price={Number(selectedDoctor?.price)}
                currency={Number(selectedDoctor?.currency)}
              />
            </Typography>
          </InfoWrapper>
          <Box className={!isMobile ? classes.flexLayout : {}}>
            {!isMobile && (
              <Box className={classes.sidebarTank}>
                <ClinicStep step={3} />
              </Box>
            )}
            <Box className={isMobile ? {} : classes.sidebarContent}>
              <InfoWrapper title={isMobile ? t('glossary.appointment_detail') : null} titleVariant="h3">
                <Box color="secondary.main" mb={0.5} mt={!isMobile && -2} fontSize={!isMobile && 16}>
                  {t('common.order_tips')}
                </Box>
                <Box
                  border={!isMobile && '1.5px solid #E5E7EB'}
                  borderRadius={!isMobile && 24}
                  maxWidth={isMobile ? null : 850}
                  p={!isMobile && 5}
                  mt={!isMobile && 3}
                >
                  {' '}
                  <Box display="flex" alignItems="center" my={isMobile ? 1 : 0}>
                    <LocationOnOutlinedIcon
                      variant="outline"
                      style={{ fontSize: isMobile ? 24 : 20, marginRight: 4 }}
                    />
                    <Box component="span" fontSize={isMobile ? 16 : 20} fontWeight={600}>
                      {selectedDoctor?.[tB('testCenterName')]}
                    </Box>
                  </Box>{' '}
                  <Box fontSize={isMobile ? 14 : 16} ml={2.5} mb={2} mt={isMobile ? 0 : 0.5} color="#4B5563">
                    {selectedDoctor?.[tB('testCenterAddress')]}
                  </Box>
                  <Divider style={{ background: '#E5E7EB' }} />
                  <Box display="flex" alignItems="center" my={isMobile ? 2 : 3}>
                    <DateRangeOutlinedIcon
                      variant="outline"
                      style={{ fontSize: isMobile ? 24 : 20, marginRight: 4, fontWeight: 500 }}
                    />
                    <Box
                      component="span"
                      fontSize={isMobile ? 16 : 16}
                      mr={4}
                      display="flex"
                      alignItems="center"
                    >
                      {formatDate(new Date(selectedDoctor?.appointmentDate))}
                    </Box>
                    <Divider orientation="vertical" flexItem style={{ background: '#E5E7EB' }} />
                    <Box component="span" mx={4} display="flex" ml={2} alignItems="center">
                      <AccessTimeIcon
                        variant="outline"
                        style={{ fontSize: isMobile ? 24 : 20, marginRight: 4 }}
                      />
                      <Box fontSize={isMobile ? 16 : 16}> {selectedDoctor?.appointmentTime}</Box>
                    </Box>
                  </Box>
                  <Divider style={{ background: '#E5E7EB' }} />
                  <Box display="flex" alignItems="center" my={isMobile ? 2 : 0} mt={isMobile ? 2 : 3}>
                    <PermContactCalendarOutlinedIcon
                      variant="outline"
                      style={{ fontSize: 24, marginRight: 4 }}
                    />
                    <Box component="span" fontSize={isMobile ? 16 : 16} fontWeight={700}>
                      {selectedDoctor?.[tB('name')] || ''}
                    </Box>
                  </Box>
                </Box>

                {isMobile && <Divider style={{ background: '#E5E7EB' }} />}
              </InfoWrapper>{' '}
              {!isMobile && <Divider className={classes.spacingDivider} />}
              <Box
                border={!isMobile && '1.5px solid #E5E7EB'}
                borderRadius={!isMobile && 24}
                maxWidth={isMobile ? null : 850}
                p={!isMobile && 5}
                mt={!isMobile && 3}
                ml={!isMobile && 2}
              >
                <InfoWrapper>
                  <Box fontSize={isMobile ? 16 : 23} fontWeight={600} mt={!isMobile && -2} mb={2}>
                    {t('glossary.consent_form')}
                  </Box>
                  <Divider style={{ marginBottom: '10px', background: '#E5E7EB' }} />
                  <FormControlLabel
                    classes={{
                      root: classes.root,
                      label: classes.label,
                    }}
                    control={
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon className={classes.checkbox} />}
                        checkedIcon={<CheckBoxIcon className={classes.checkbox} />}
                        Checkbox
                        checked={check}
                        onChange={handleChangeCheck}
                        inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
                      />
                    }
                    label={
                      <span
                        fontSize={18}
                        dangerouslySetInnerHTML={{
                          __html:
                            agreementStatus === 'pending'
                              ? t('glossary.loading_term')
                              : agreement[tB('content')] ||
                                t('tips.empty_data', { field: '$t(glossary.agreement)' }),
                        }}
                      />
                    }
                  />

                  {isMobile ? (
                    <EDrawer
                      isAgreement
                      open={openAgreement}
                      onClose={() => setOpenAgreement(false)}
                      title={t('glossary.consent_form')}
                    >
                      <Divider style={{ marginBottom: '10px', background: '#E5E7EB' }} />
                      <Box
                        color="grey.600"
                        lineHeight={1.5}
                        fontSize="body1.fontSize"
                        dangerouslySetInnerHTML={{
                          __html:
                            agreementStatus === 'pending'
                              ? t('glossary.loading_term')
                              : agreement[tB('content')] ||
                                t('tips.empty_data', { field: '$t(glossary.agreement)' }),
                        }}
                      />

                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        onClick={handleCloseAgreement}
                        style={{ marginTop: '16px' }}
                      >
                        {t('glossary.had_read_agree_and_continue')}
                        {/* {t('glossary.had_read_agreement')} */}
                      </Button>
                    </EDrawer>
                  ) : (
                    <Dialog
                      maxWidth="xs"
                      fullWidth
                      open={openAgreement}
                      onClose={() => setOpenAgreement(false)}
                    >
                      <DialogTitle
                        style={{
                          textAlign: 'center',
                          color: '#111',
                          background: '#fff',

                          borderBottom: '1px solid #E5E7EB',
                        }}
                      >
                        <Box fontWeight={600}>{t('glossary.consent_form')}</Box>
                        <IconButton
                          aria-label="close"
                          className={classes.closeButton}
                          onClick={() => setOpenAgreement(false)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <Box
                        p={2}
                        color="grey.600"
                        lineHeight={1.5}
                        fontSize="body1.fontSize"
                        dangerouslySetInnerHTML={{
                          __html:
                            agreementStatus === 'pending'
                              ? t('glossary.loading_term')
                              : agreement[tB('content')] ||
                                t('tips.empty_data', { field: '$t(glossary.agreement)' }),
                        }}
                      />
                      <DialogActions>
                        <Button variant="contained" color="secondary" onClick={handleCloseAgreement}>
                          {t('glossary.had_read_agree_and_continue')}
                          {/* {t('glossary.had_read_agreement')} */}
                        </Button>
                      </DialogActions>
                    </Dialog>
                  )}
                </InfoWrapper>
              </Box>
              <Box padding={2} lineHeight="150%" maxWidth={850}>
                <Typography fontSize={isMobile ? 14 : 16} color="#4B5563">
                  {t('common.declare_duty')}
                </Typography>
              </Box>
              {isMobile ? <FixedButtonWrapper>{renderButton()}</FixedButtonWrapper> : renderButton()}
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}

export default AddOrder
